export default "__VITE_ASSET__LIgagwwv__"